import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BatchItem } from 'src/interfaces/batch';
import { RawOrderItem } from 'src/interfaces/order';
import { OrderItem } from 'src/interfaces/order-item';

interface DialogData {
  rawOrderItem: RawOrderItem | null,
  orderItem: OrderItem | null
}

@Component({
    selector: 'app-order-item-details-dialog',
    templateUrl: './order-item-details-dialog.component.html',
    styleUrls: ['./order-item-details-dialog.component.scss'],
    standalone: false
})
export class OrderItemDetailsDialogComponent implements OnInit {

  displayedColumns: string[] = [
    'id',
    'barcode',
    'medicine_number'
  ];

  batchItems: BatchItem[] = [];

  constructor(
    public _dialogRef: MatDialogRef<OrderItemDetailsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
  ) { }

  ngOnInit(): void {

    if (this.data.orderItem)
      if (this.data.orderItem.batch_items) {
        this.batchItems = this.data.orderItem.batch_items;
      }

    if (this.data.rawOrderItem) {
      if (this.data.rawOrderItem.batch_items) {
        this.batchItems = this.data.rawOrderItem.batch_items;
      }
    }

  }

  closeDialog() {
    this._dialogRef.close(true);
  }

  get dialogTitle(): string {
    const label = this.labelName;
    const dosage = this.dosageInfo;
    if (label && dosage) {
      return `${label} — ${dosage}`;
    }
    return label || dosage || 'Medicine details';
  }

  get labelName(): string {
    if (this.data.orderItem?.medicineDosagePackageType?.label_name) {
      return this.data.orderItem.medicineDosagePackageType.label_name;
    }
    if (this.data.rawOrderItem?.medicine_dosage_package_type?.label_name) {
      return this.data.rawOrderItem.medicine_dosage_package_type.label_name;
    }
    return '—';
  }

  get dosageInfo(): string {
    if (this.data.orderItem?.dosageType?.additional_information) {
      return this.data.orderItem.dosageType.additional_information;
    }
    if (
      this.data.rawOrderItem?.medicine_dosage_package_type?.medicine_dosage_type
        ?.additional_information
    ) {
      return this.data.rawOrderItem.medicine_dosage_package_type
        .medicine_dosage_type.additional_information;
    }
    return '—';
  }

  get medicineNumber(): string {
    if (
      this.data.orderItem?.medicineDosagePackageType?.medicine_dosage_type
        ?.medicine_number
    ) {
      return this.data.orderItem.medicineDosagePackageType.medicine_dosage_type
        .medicine_number;
    }
    if (
      this.data.rawOrderItem?.medicine_dosage_package_type?.medicine_dosage_type
        ?.medicine_number
    ) {
      return this.data.rawOrderItem.medicine_dosage_package_type
        .medicine_dosage_type.medicine_number;
    }
    return '—';
  }

}
